import { getStoreDefinition } from '@/composables/StoreDefinition'
import { TableStoreOptions } from '@/enums/TableStoreOptions'
import type { ITableStore } from '@/interfaces/api/ITableStore'
import { defineStore } from 'pinia'

export const useFilesStore = (): ITableStore => {
  const option = TableStoreOptions.Files
  const useStore = defineStore(option.id, getStoreDefinition(option), {
    persist: {
      storage: localStorage,
      pick: ['itemsPerPage']
    }
  })
  return useStore() as unknown as ITableStore
}
